import ProductLightboxController from "mercor/product_lightbox_controller";
import axios from "lib/axios";
import BaseController from "confinus_ui/base_controller";
import { closeModal, showConfirmModal } from "lib/overlay/modal";
import { ModalLifecycleEvent } from "confinus_ui/modal_controller";
import { Mercor__ProductLightboxControllerIdentifier } from "controllers/identifiers";

export default class CartItemController extends BaseController {
  public static values = {
    url: { type: String, default: null },
  };

  declare private readonly urlValue: any;
  public static outlets = [Mercor__ProductLightboxControllerIdentifier];
  declare private readonly mercorProductLightboxOutlets: ProductLightboxController[];
  private get lightboxControllers() {
    return this.mercorProductLightboxOutlets;
  }

  public edit() {
    this.lightboxControllers.forEach((controller) => {
      // controller.showPurchaseConfigurator(); ???
    });
  }

  public removalWithoutConfirm() {
    this.deleteCartItem();
  }

  public showRemovalConfirm() {
    showConfirmModal({
      defaultReason: "ok",
      negativeButtonReason: "cancel",
      negativeButtonLabel: "No",
      positiveButtonReason: "ok",
      positiveButtonLabel: "Yes",
      message: "Are you sure that you want to delete this item?",
      onClosing: this.handleDialogClosing,
    });
  }

  private handleDialogClosing = ({
    detail: { closeReason },
  }: ModalLifecycleEvent) => {
    if (closeReason === "ok") {
      this.deleteCartItem();
    } else {
      closeModal();
    }
  };

  private deleteCartItem() {
    const url = this.urlValue;

    if (url === null) {
      return;
    }

    axios
      .delete(url)
      .then(() => {
        window.location.reload();
      })
      .catch((e: Error) => {
        console.error("Could not delete item from cart... " + url);
        console.log(e.stack);
        console.log(e.message);
      });
  }
}
